import { FC } from 'react'

import { DailyReport } from 'commons/types/DTO/bank/salesDataSourceWebPage/DailyReport'
import { TableDataQa } from 'commons/types/enums'
import { formatCurrencyCent } from 'commons/utils'
import { IconName, IconSize, Layer, PageSection, Table } from 'ui/components'
import { DownloadLink } from 'ui/components/DownloadLink'

import { MetrcSourceTableProps } from './MetrcSourceTableProps'

import { ErrorIcon } from './styles'

export const MetrcSourceTable: FC<MetrcSourceTableProps> = (props) => {
  const { webPage } = props

  return (
    <PageSection
      title="Daily Metrc Data"
      anchor="metrc"
      actions={
        <DownloadLink
          direct
          parametersForm={{
            salesDataSourceId: webPage.salesDataSourceId
          }}
          handleError={() => ({})}
          baseUrl="/bank/v1/sales-data/sics-source-download-csv"
          name={'Metrc Source.csv'}
        >
          Download .csv
        </DownloadLink>
      }
    >
      <Layer shadowed rounded>
        <Table<DailyReport>
          dataQa={TableDataQa.BP_SALESDATA_SOURCE_DETAILS_METRC_SOURCE}
          columns={[
            {
              title: 'Date',
              key: 'date',
              sortable: false,
              align: 'left'
            },
            {
              title: 'Alert',
              sortable: false,
              align: 'left',
              render: ({ alert }) => (
                <>
                  {alert.length > 0 && (
                    <>
                      <ErrorIcon size={IconSize.S} name={IconName.ERROR} /> {alert}
                    </>
                  )}
                </>
              )
            },
            {
              title: 'Total Sales Amount $',
              sortable: false,
              align: 'left',
              render: ({ totalSold }) => formatCurrencyCent(totalSold)
            }
          ]}
          dataSource={webPage.dailyReports.map((daily) => ({
            item: daily,
            rowProps: { errorHighlight: daily.alert.length > 0 }
          }))}
        />
      </Layer>
    </PageSection>
  )
}
